module.exports = __webpack_public_path__ + "img/support1.603349b5.svg";